import { AppVersionService } from './modules/shared/services/app-version.service';
import { AnnouncementService } from './modules/shared/services/announcement.service';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { utilityService } from "./modules/shared/services/utility.service";
import { environment } from "src/environments/environment";
import { authService } from "./modules/shared/services/auth.service";
import { coinsService } from "./modules/shared/services/coins.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = "coin-web";

  constructor(
    private utility: utilityService,
    private coinService: coinsService,
    private auth: authService,
    public versions: AppVersionService,
    public announcements: AnnouncementService
  ) {}

  ngOnInit(): void {
    this.versions.start();
    this.announcements.start();
    this.reupdateAppData();
  }

  ngOnDestroy(): void {
    this.versions.ngOnDestroy();
    this.announcements.ngOnDestroy();
  }

  //update app data
  reupdateAppData() {
    const token = localStorage.getItem(environment.token_lable);
    if (!token) {
      return;
    }
    this.auth.getLoggedInUserData(token);
  }
}
